const LINK_REGEXP = /([^\s"']+\.[a-zA-Z]{2,3}([^\s"']+)?)|(https?:\/\/[^\s"']+)/;
const HTTPS_REGEXP = /^(https?:\/\/)/;
const LINK_TAG_START_REGEXP = /<a/;
export const linkToAnchor = (link) => {
    const prefix = link.match(HTTPS_REGEXP) ? '' : 'https://';
    const encodedLink = link.replace(/["\\]/g, encodeURIComponent);
    return `<a href="${prefix}${encodedLink}" target="_blank">${link}</a>`;
};
export const makeLinksClickable = (text) => {
    if (text.match(LINK_TAG_START_REGEXP)) {
        return text;
    }
    return text.replace(LINK_REGEXP, linkToAnchor);
};
//# sourceMappingURL=utils.js.map